import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/operator/map';
import { AppService, BASE_URL_TRANSLATION } from '../app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TranslationService extends AppService {

  constructor(private _http: HttpClient, private _translation: TranslateService) {
    super(_http);
  }

  stringToObj(path, value, obj): any {
    const parts = path.split('.');
    let part;
    const last = parts.pop();
    while (part = parts.shift()) {
      if (typeof obj[part] !== 'object') {
        obj[part] = {};
      }
      obj = obj[part]; // update "pointer"
    }
    obj[last] = value;
  }

  getDataTableTranslation(): any {
    // Usage: this._translation.getDataTableTranslation().subscribe(dataTableTranslation => console.log(dataTableTranslation));
    const keys = [
      'DATATABLE.oAria.sSortAscending',
      'DATATABLE.oAria.sSortDescending',
      'DATATABLE.oPaginate.sFirst',
      'DATATABLE.oPaginate.sLast',
      'DATATABLE.oPaginate.sNext',
      'DATATABLE.oPaginate.sPrevious',
      'DATATABLE.sEmptyTable',
      'DATATABLE.sInfo',
      'DATATABLE.sInfoEmpty',
      'DATATABLE.sInfoFiltered',
      'DATATABLE.sInfoThousands',
      'DATATABLE.sLengthMenu',
      'DATATABLE.sLoadingRecords',
      'DATATABLE.sProcessing',
      'DATATABLE.sSearch',
      'DATATABLE.sZeroRecords',
    ];
    return this._translation.get(keys).map((res) => {
      const resObj = {};
      for (const key in res) {
        if (res.hasOwnProperty(key)) {
          this.stringToObj(key, res[key], resObj);
        }
      }
      return resObj['DATATABLE'];
    });
  }

  getLocaleSettingsById(localeId: string): Observable<any> {
    this.endpoint = `${BASE_URL_TRANSLATION}/locales/${localeId}/settings`;
    return this.get(this.endpoint);
  }

  setUserLanguage(localeId: string, userId: number): Observable<any> {
    this.endpoint = `${BASE_URL_TRANSLATION}/locales/${localeId}/users/${userId}`;
    return this.post(this.endpoint, {});
  }

  getEnabledLocales(): Observable<any> {
    this.endpoint = `${BASE_URL_TRANSLATION}/locales/enabled`;
    return this.get(this.endpoint);
  }
}




// WEBPACK FOOTER //
// ./src/app/services/translation.service.ts